/*
 * @Description:
 * @Author: zwcong
 * @Date: 2025-08-01 14:44:08
 * @LastEditors: zwcong
 * @LastEditTime: 2025-08-04 16:08:16
 */
/**
 * 公共配置
 */
/* eslint-disable global-require */
export default {
  logo: {
    // 彩色常规LOGO
    normal: require('assets/images/common/logo.webp'),
    white: require('assets/images/common/logo.webp'),
    // 白色常规LOGO
    normalWhite: require('assets/images/common/logo-white.png'),
    // 彩色LOGO图标
    simple: require('assets/images/common/icon-logo.svg'),
    // 白色LOGO图标
    simpleWhite: require('assets/images/common/icon-logo-white.svg'),
    // 加载中图标
    loading: require('assets/images/common/logo-loading.png'),
  },
  // 日期格式化方式
  dateFormatLine: 'DD-MM-YYYY',
  // 重试
  retry: 'Retry',
  // 尾部是否显示邮箱
  showContactEmail: true,
  // 联系电话显示字符
  contactPhoneString: '',
  parent: 'Parent',
  stage3Null: 'Appointments are temporarily unavailable. We recommend that you start an online evaluation directly.',
  // 请输入邮箱
  emailPlaceholder: 'Please enter your email',
  // 请输入正确的邮箱
  emailError: 'Please enter the correct email',
}
